import type { merchantsAPI } from '@backmarket/http-api'

import type { TransformedCategory } from './BatchListingCreation.types'

export function transform(
  data: merchantsAPI.GetDocwebsiteCategories,
): TransformedCategory[] {
  return data
    .map((level1) =>
      level1.childrens.flatMap((level2) => [
        { ...level2, categoryLevel: 2, parentCategoryId: level1.categoryId },
        ...level2.childrens.map((level3) => ({
          ...level3,
          parentCategoryId: level2.categoryId,
          categoryLevel: 3,
        })),
      ]),
    )
    .flat()
}
